import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { dayColor, makeRowColumn, getHeadObj } from 'lib/commonLib';
import { returnDayReport } from 'lib/api/return';

import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SpanningTableContents from 'components/molecules/MbTable/SpanningTableContents';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const Statistics = () => {
  const { t } = useTranslation();

  const [initialization, setInitialization] = useState(false);
  const initParams = {
    sort: 'desc',
    order: 'STATS_DTTM',
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
  };
  const [params, setParams] = useState(initParams);
  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    STATS_DTTM: {
      makeBody: (rowObj, headsMap) => {
        return rowObj['STATS_DTTM'] !== 'total'
          ? dayColor(makeRowColumn(rowObj['STATS_DTTM']))
          : rowObj['STATS_DTTM'];
      },
      orderFlag: false,
    },
    CLICK_CNT: {
      makeHead: (headsMap) => {
        return (
          <SpanningTableContents topTitle={t('클릭수')} type="head">
            <div style={{ width: 70 }}>{t('전체')}</div>
            <div style={{ width: 70 }}>{t('웹')}</div>
            <div style={{ width: 70 }}>{t('모바일')}</div>
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'CLICK_CNT');
        const bodyItem2 = getHeadObj(headsMap, 'W_CLICK_CNT');
        const bodyItem3 = getHeadObj(headsMap, 'M_CLICK_CNT');
        return (
          <SpanningTableContents>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['CLICK_CNT'],
                bodyItem1.type,
                bodyItem1.format
              )}
            </div>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['W_CLICK_CNT'],
                bodyItem2.type,
                bodyItem2.format
              )}
            </div>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['M_CLICK_CNT'],
                bodyItem3.type,
                bodyItem3.format
              )}
            </div>
          </SpanningTableContents>
        );
      },
      orderFlag: false,
    },
    W_CLICK_CNT: { merged: true },
    M_CLICK_CNT: { merged: true },
    W_RETRN_00_CNT: {
      makeHead: (headsMap) => {
        return (
          <SpanningTableContents topTitle={t('웹 이탈 / 단순 유입 / 유효')} type={'head'}>
            <div style={{ width: 70 }}>
              <InfoTitleArea
                title={t('이탈수')}
                tooltipTitle={'클릭 후 1초 미만에 이탈하거나 스크립트 작동이 안한 무효 클릭'}
                iconType="fainfoCircle"
              />
            </div>
            <div style={{ width: 70 }}>{t('이탈률')}</div>
            <div style={{ width: 70 }}>
              <InfoTitleArea
                title={t('단순 유입수')}
                tooltipTitle={'클릭 후 1초가 지났지만 10초 이전에 나간 무효 클릭'}
                iconType="fainfoCircle"
              />
            </div>
            <div style={{ width: 70 }}>{t('단순 유입률')}</div>
            <div style={{ width: 70 }}>
              <InfoTitleArea
                title={t('유효수')}
                tooltipTitle={'체류시간 10초 이상, pv 2회인 유효 클릭'}
                iconType="fainfoCircle"
              />
            </div>
            <div style={{ width: 70 }}>{t('유효율')}</div>
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const wRetrn00Cnt = getHeadObj(headsMap, 'W_RETRN_00_CNT');
        const wRetrn00Rate = getHeadObj(headsMap, 'W_RETRN_00_RATE');
        const wRetrn01Cnt = getHeadObj(headsMap, 'W_RETRN_01_CNT');
        const wRetrn01Rate = getHeadObj(headsMap, 'W_RETRN_01_RATE');
        const wAvalCnt = getHeadObj(headsMap, 'W_AVAL_CNT');
        const wAvalRate = getHeadObj(headsMap, 'W_AVAL_RATE');
        return (
          <SpanningTableContents>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['W_RETRN_00_CNT'],
                wRetrn00Cnt.type,
                wRetrn00Cnt.format
              )}
            </div>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['W_RETRN_00_RATE'],
                  wRetrn00Rate.type,
                  wRetrn00Rate.format
              )}
            </div>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['W_RETRN_01_CNT'],
                  wRetrn01Cnt.type,
                  wRetrn01Cnt.format
              )}
            </div>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['W_RETRN_01_RATE'],
                  wRetrn01Rate.type,
                  wRetrn01Rate.format
              )}
            </div>
              <div style={{ width: 70 }}>
                  {makeRowColumn(
                      rowObj['W_AVAL_CNT'],
                      wAvalCnt.type,
                      wAvalCnt.format
                  )}
              </div>
              <div style={{ width: 70 }}>
                  {makeRowColumn(
                      rowObj['W_AVAL_RATE'],
                      wAvalRate.type,
                      wAvalRate.format
                  )}
              </div>
          </SpanningTableContents>
        );
      },
      headStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
      bodyStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
    },
    W_RETRN_00_RATE: { merged: true },
    W_RETRN_01_CNT: { merged: true },
    W_RETRN_01_RATE: { merged: true },
    W_AVAL_CNT: { merged: true },
    W_AVAL_RATE: { merged: true },
    M_RETRN_00_CNT: {
      makeHead: (headsMap) => {
        return (
          <SpanningTableContents topTitle={t('모바일 이탈 / 단순 유입 / 유효')} type={'head'}>
            <div style={{ width: 70 }}>
              <InfoTitleArea
                title={t('이탈수')}
                tooltipTitle={'클릭 후 1초 미만에 이탈하거나 스크립트 작동이 안한 무효 클릭'}
                iconType="fainfoCircle"
              />
            </div>
            <div style={{ width: 70 }}>{t('이탈률')}</div>
            <div style={{ width: 70 }}>
              <InfoTitleArea
                title={t('단순 유입수')}
                tooltipTitle={'클릭 후 1초가 지났지만 10초 이전에 나간 무효 클릭'}
                iconType="fainfoCircle"
              />
            </div>
            <div style={{ width: 70 }}>{t('단순 유입률')}</div>
            <div style={{ width: 70 }}>
              <InfoTitleArea
                title={t('유효수')}
                tooltipTitle={'체류시간 10초 이상, pv 2회인 유효 클릭'}
                iconType="fainfoCircle"
              />
            </div>
            <div style={{ width: 70 }}>{t('유효율')}</div>
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const mRetrn00Cnt = getHeadObj(headsMap, 'M_RETRN_00_CNT');
        const mRetrn00Rate = getHeadObj(headsMap, 'M_RETRN_00_RATE');
        const mRetrn01Cnt = getHeadObj(headsMap, 'M_RETRN_01_CNT');
        const mRetrn01Rate = getHeadObj(headsMap, 'M_RETRN_01_RATE');
        const mAvalCnt = getHeadObj(headsMap, 'M_AVAL_CNT');
        const mAvalRate = getHeadObj(headsMap, 'M_AVAL_RATE');
        return (
          <SpanningTableContents>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['M_RETRN_00_CNT'],
                mRetrn00Cnt.type,
                mRetrn00Cnt.format
              )}
            </div>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['M_RETRN_00_RATE'],
                mRetrn00Rate.type,
                mRetrn00Rate.format
              )}
            </div>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['M_RETRN_01_CNT'],
                mRetrn01Cnt.type,
                mRetrn01Cnt.format
              )}
            </div>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['M_RETRN_01_RATE'],
                mRetrn01Rate.type,
                mRetrn01Rate.format
              )}
            </div>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['M_AVAL_CNT'],
                mAvalCnt.type,
                mAvalCnt.format
              )}
            </div>
            <div style={{ width: 70 }}>
              {makeRowColumn(
                rowObj['M_AVAL_RATE'],
                mAvalRate.type,
                mAvalRate.format
              )}
            </div>
          </SpanningTableContents>
        );
      },
      headStyle: { borderRight: '1px solid #e5e8eb' },
      bodyStyle: { borderRight: '1px solid #e5e8eb' },
    },
    M_RETRN_00_RATE: { merged: true },
    M_RETRN_01_CNT: { merged: true },
    M_RETRN_01_RATE: { merged: true },
    M_AVAL_CNT: { merged: true },
    M_AVAL_RATE: { merged: true },
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useExternalFilter={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={returnDayReport}
        customized={customized}
        rowsPerPage={-1}
        useFetch={false}
        useSearch={false}
        usePagenation={false}
      />
    </>
  );
};

export default Statistics;
